import React from "react";
import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";
import IntegrationsBar from "./IntegrationsBar";
import SolutionChecklist, { SolutionChecklistItem } from "./SolutionChecklist";
import revPrepBanner from "../images/landing-page/revolution-prep-banner.png";
import "../styles/solutions-page.css";
import "../styles/landing-page.css";

const SCHOOL_INTRO =
    "Polaris Athlete Hub provides schools and districts with a centralized platform designed to support student-athlete success. From NIL education and college readiness to team management and streamlined communication, all the tools you need to guide athletes, accessible in one place—making it easier to develop talent, track progress, and keep your programs running smoothly.";

const SCHOOL_FEATURES: SolutionChecklistItem[] = [
    {
        title: "Fully Branded Platform",
        description:
            "Create a platform that reflects your school or organization. Upload your logo and branding so student-athletes engage with resources in a space that feels like your program.",
    },
    {
        title: "NIL Education For Your Community",
        description:
            "Provide student-athletes, coaches, and staff with structured NIL education, including advanced programming like the NIL MBA course led by Bill Carter.",
    },
    {
        title: "Team & Roster Management",
        description:
            "Easily manage teams, organize rosters, and communicate with athletes in one centralized platform.",
    },
    {
        title: "Curated Events & Programming",
        description:
            "Give administrators, staff, and student-athletes access to expert-led programming in college counseling, NIL education, and test preparation.",
    },
    {
        title: "Google Integration",
        description:
            "Sync your Google Calendar and Google Drive with Polaris Athlete. Plus, enjoy seamless SSO login via Google, making it easy for athletes, coaches, and staff to access everything they need without extra credentials.",
    },
    {
        title: "Clever Integration",
        description:
            "We integrate seamlessly with Clever to provide secure, streamlined SSO login. Your school or organization can manage users with confidence, knowing access is safe, simple, and centralized.",
    },
    {
        title: "Stripe Integration",
        description:
            "All billing and payments are handled securely through Stripe, one of the most trusted payment platforms. You can rest assured your transactions are safe, reliable, and easy to manage.",
    },
];

export default function SchoolsPage() {
    return (
        <main className="solution-page">
            <PublicHeader />

            <section className="solution-hero">
                <h1 className="solution-hero-heading">For Schools</h1>
                <p className="solution-hero-intro">{SCHOOL_INTRO}</p>
            </section>

            <section className="solution-features-section">
                <div className="solution-features-card">
                    <p className="solution-features-label">
                        <span className="solution-features-diamond" aria-hidden="true">✦</span> Our features
                    </p>
                    <h2 className="solution-features-heading">
                        Built For Schools Supporting Student-Athletes.
                    </h2>
                    <SolutionChecklist items={SCHOOL_FEATURES} />
                </div>
            </section>

            <IntegrationsBar />

            <section className="landing-revprep">
                <div className="landing-revprep-inner">
                    <div className="landing-revprep-banner">
                        <img
                            src={revPrepBanner}
                            alt="Revolution Prep"
                            className="landing-revprep-banner-logo"
                        />
                        <div className="landing-revprep-banner-content">
                            <h3 className="landing-revprep-banner-heading">Free Test Prep &amp; Tutoring</h3>
                            <p className="landing-revprep-banner-desc">
                                All student-athletes receive 2 hours ($200+ value) of complimentary test prep
                                or tutoring through our partner, RevPrep, helping them strengthen academic
                                skills and stay on track for college success.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <PublicFooter />
        </main>
    );
}
